import { getFirstLineTitle, getSecondLineTextAndTitle } from '../utils/getAttachmentInfo';
import { observer } from 'mobx-react';
import { AttachmentViewState } from 'owa-attachment-data';
import { AttachmentDocInfoViewBase } from 'owa-attachment-common-view';
import { AttachmentModel } from 'owa-attachment-model-store';
import { highlightTermsInHtmlElement } from 'owa-mail-highlight-terms';
import * as React from 'react';

export interface AttachmentDocInfoProps {
    attachmentViewState: AttachmentViewState;
    attachment: AttachmentModel;
    firstLineStyle: string;
    secondLineStyle: string;
    isShortDocView: boolean;
}

@observer
export default class AttachmentDocInfoView extends React.Component<AttachmentDocInfoProps, any> {
    render() {
        const firstLineTitle = getFirstLineTitle(
            this.props.attachmentViewState,
            this.props.attachment
        );

        const secondLine = getSecondLineTextAndTitle(
            this.props.attachmentViewState,
            this.props.attachment
        );
        return (
            <AttachmentDocInfoViewBase
                firstLineStyle={this.props.firstLineStyle}
                firstLineText={this.props.attachment.model.Name}
                firstLineTitle={firstLineTitle}
                highlightAttachmentName={this.highlightAttachmentName}
                isShortDocView={this.props.isShortDocView}
                secondLineStyle={this.props.secondLineStyle}
                secondLineText={secondLine.text}
                secondLineTitle={secondLine.title ? secondLine.title : firstLineTitle}
            />
        );
    }

    private highlightAttachmentName(ref: HTMLDivElement) {
        highlightTermsInHtmlElement(ref);
    }
}
